<template>
  <v-row>

    <!-- ══════════════════════════════════════════════════════════════════════
         Tela de boas-vindas — exibida para todos os usuários
    ══════════════════════════════════════════════════════════════════════ -->
    <template>

      <!-- ── 1. Sobre a WoliHub (cols=12) ───────────────────────────────── -->
      <v-col cols="12" class="pb-2">
        <v-card elevation="0" outlined style="border-radius: 12px; overflow: hidden;">

          <div class="sobre-header">
            <div class="sobre-header-icon">
              <v-icon size="18" color="white">mdi-book-open-page-variant-outline</v-icon>
            </div>
            <div>
              <div class="sobre-header-title">WoliHub</div>
              <div class="sobre-header-sub">Plataforma de e-books e cursos</div>
            </div>
          </div>

          <div class="sobre-body">

            <!-- Descrição -->
            <div class="sobre-desc-col">
              <p class="sobre-desc">
                A <a
                  href="https://educacomercialivaipora.wolihub.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="sobre-link"
                >WoliHub</a> é uma plataforma de <strong>e-books e cursos online</strong>
                oferecida como benefício aos clientes da loja. Ao atingir o valor mínimo do
                pedido, o cliente recebe um <strong>bônus de e-books</strong> sem custo adicional
                — todo o conteúdo fica disponível para acesso direto pelo site da plataforma.
              </p>

              <!-- Exemplo prático -->
              <div class="sobre-exemplo">
                <div class="sobre-exemplo-icone">
                  <v-icon size="14" color="#0477a1">mdi-lightbulb-on-outline</v-icon>
                </div>
                <div>
                  <span class="sobre-exemplo-titulo">Exemplo prático</span>
                  <span class="sobre-exemplo-texto">
                    Pedido de <strong>R$&nbsp;350</strong> → sistema inclui o
                    <strong>Combo Bronze</strong> → cliente ganha
                    <strong>4&nbsp;e-books</strong> de brinde com
                    <strong>R$&nbsp;100</strong> de desconto rateado no pedido
                  </span>
                </div>
              </div>

            </div>

          </div>

        </v-card>
      </v-col>

      <!-- ── 2. Etapas do processo (cols=12 md=6) ─────────────────────── -->
      <v-col cols="12" md="6" class="pb-2">
        <v-card elevation="0" outlined class="fluxo-card" style="border-radius: 12px; overflow: hidden;">

          <div class="fluxo-header">
            <div class="fluxo-header-left">
              <div class="fluxo-header-icon">
                <v-icon size="16" color="white">mdi-format-list-numbered</v-icon>
              </div>
              <div>
                <div class="fluxo-header-title">Etapas do processo</div>
                <div class="fluxo-header-sub">Da compra à liberação do conteúdo</div>
              </div>
            </div>
          </div>

          <v-card-text class="pt-4 px-4 pb-2">

            <!-- Lista de passos (vertical) -->
            <div class="fluxo-lista">
              <div
                v-for="(etapa, i) in fluxo"
                :key="`etapa-${i}`"
                class="fluxo-item"
              >
                <!-- Lado esquerdo: ícone + linha conectora -->
                <div class="fluxo-item-esq">
                  <div class="fluxo-item-wrap">
                    <div
                      class="fluxo-item-icon"
                      :style="{ background: etapa.cor + '14', border: `2px solid ${etapa.cor}28` }"
                    >
                      <v-icon :color="etapa.cor" size="22">{{ etapa.icon }}</v-icon>
                    </div>
                    <div class="fluxo-item-num" :style="{ background: etapa.cor }">{{ i + 1 }}</div>
                  </div>
                  <div v-if="i < fluxo.length - 1" class="fluxo-item-linha" />
                </div>
                <!-- Lado direito: texto -->
                <div class="fluxo-item-texto">
                  <div class="fluxo-item-label">{{ etapa.label }}</div>
                  <div class="fluxo-item-desc">{{ etapa.desc }}</div>
                </div>
              </div>
            </div>

          </v-card-text>

        </v-card>
      </v-col>

      <!-- ── 3. Combos (cols=12 md=6) ──────────────────────────────────── -->
      <v-col cols="12" md="6" class="pb-2">
        <v-card elevation="0" outlined class="combos-card" style="border-radius: 12px; overflow: hidden;">

          <div class="combos-header">
            <div class="combos-header-left">
              <div class="combos-header-icon">
                <v-icon size="16" color="white">mdi-package-variant-closed</v-icon>
              </div>
              <div>
                <div class="combos-header-title">Combos de E-books</div>
                <div class="combos-header-sub">Bonificação automática por faixa de valor</div>
              </div>
            </div>
            <v-chip
              x-small
              color="rgba(255,255,255,0.15)"
              dark
              style="font-size: 10px; border: 1px solid rgba(255,255,255,0.2);"
            >
              {{ combos.length }} combos
            </v-chip>
          </div>

          <v-simple-table class="combos-table">
            <thead>
              <tr class="combos-thead">
                <th class="text-caption combos-th">Combo</th>
                <th class="text-caption combos-th">Faixa do Pedido</th>
                <th class="text-caption combos-th text-center">E-books</th>
                <th class="text-caption combos-th text-right">Desconto</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(combo, i) in combos"
                :key="combo.nome"
                class="combos-row"
                :class="{ 'combos-row--alt': i % 2 !== 0 }"
              >
                <td class="combos-td">
                  <v-chip
                    small
                    :color="combo.cor"
                    dark
                    style="font-weight: 700; font-size: 11px; letter-spacing: 0.3px;"
                  >
                    {{ combo.nome }}
                  </v-chip>
                </td>
                <td class="combos-td combos-td--faixa">
                  <div class="faixa-wrap">
                    <span class="faixa-de">{{ combo.valormin | formataDinheiro }}</span>
                    <v-icon x-small color="#b0bec5" class="mx-1">mdi-arrow-right</v-icon>
                    <template v-if="combo.valormax">
                      <span class="faixa-ate">{{ combo.valormax | formataDinheiro }}</span>
                    </template>
                    <template v-else>
                      <span class="faixa-sem-limite">sem limite</span>
                    </template>
                  </div>
                </td>
                <td class="combos-td text-center">
                  <div class="qtd-wrap">
                    <v-icon x-small color="#5a6a7a" class="mr-1">mdi-book-outline</v-icon>
                    <span class="qtd-valor">{{ combo.qtd }}</span>
                  </div>
                </td>
                <td class="combos-td text-right desconto-valor">
                  {{ combo.valor | formataDinheiro }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <div class="combos-footer">
            <v-icon x-small color="#8fa8bc" class="mr-1">mdi-information-outline</v-icon>
            <span>O desconto é rateado proporcionalmente nos produtos do pedido.</span>
          </div>

        </v-card>
      </v-col>

    </template>
  </v-row>
</template>

<script>
export default {
  name: 'WolihubInicio',

  data: () => ({
    combos: [
      { nome: 'VIP',      cor: 'blue darken-1',  qtd: 2,  valor: 50,  valormin: 100,  valormax: 300  },
      { nome: 'BRONZE',   cor: 'brown',           qtd: 4,  valor: 100, valormin: 301,  valormax: 500  },
      { nome: 'PRATA',    cor: 'blue-grey',       qtd: 6,  valor: 150, valormin: 501,  valormax: 750  },
      { nome: 'OURO',     cor: 'amber darken-2',  qtd: 8,  valor: 200, valormin: 751,  valormax: 1000 },
      { nome: 'DIAMANTE', cor: 'cyan darken-2',   qtd: 11, valor: 275, valormin: 1001, valormax: null },
    ],
    fluxo: [
      {
        label: 'Pedido feito',
        desc:  'Cliente fecha um pedido na loja — ao atingir R$ 100, já tem direito ao bônus de e-books',
        icon:  'mdi-cart-outline',
        cor:   '#1976d2',
      },
      {
        label: 'E-book incluído no pedido',
        desc:  'Sistema detecta o valor, adiciona o combo de e-books e aplica o desconto correspondente no pedido',
        icon:  'mdi-book-plus-outline',
        cor:   '#7b1fa2',
      },
      {
        label: 'Pagamento no caixa',
        desc:  'Ao efetivar o pedido no caixa, o bônus é confirmado e o e-book já consta na nota do cliente',
        icon:  'mdi-cash-register',
        cor:   '#f57c00',
      },
      {
        label: 'E-books liberados',
        desc:  'Acesso liberado automaticamente — cliente entra no conteúdo direto pelo site educacomercialivaipora.wolihub.com.br usando o CPF como login e senha',
        icon:  'mdi-web-check',
        cor:   '#388e3c',
      },
    ],
  }),
}
</script>

<style scoped>
/* ════════════════════════════════════════════════════════════════════════
   SOBRE A WOLIHUB
════════════════════════════════════════════════════════════════════════ */
.sobre-header {
  background: linear-gradient(135deg, #023449 0%, #0477a1 100%);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.sobre-header-icon {
  width: 36px;
  height: 36px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.22);
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sobre-header-title { font-size: 14px; font-weight: 700; color: white; line-height: 1.2; }
.sobre-header-sub   { font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 1px; }

.sobre-body {
  display: flex;
  align-items: stretch;
  gap: 0;
}

.sobre-desc-col {
  flex: 1;
  padding: 16px 18px;
  min-width: 0;
}
.sobre-desc {
  font-size: 13px;
  color: #5a6a7a;
  line-height: 1.7;
  margin-bottom: 10px;
}

.sobre-link {
  color: #0477a1;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1.5px solid rgba(4, 119, 161, 0.35);
  padding-bottom: 1px;
  transition: color 0.15s, border-color 0.15s;
}
.sobre-link:hover {
  color: #035878;
  border-bottom-color: #035878;
}

/* ════════════════════════════════════════════════════════════════════════
   COMBOS
════════════════════════════════════════════════════════════════════════ */
.combos-card { display: flex; flex-direction: column; }

.combos-header {
  background: linear-gradient(135deg, #1a4a5e 0%, #1e7aa0 100%);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.combos-header-left  { display: flex; align-items: center; gap: 10px; }
.combos-header-icon  {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.combos-header-title { font-size: 13px; font-weight: 700; color: white; }
.combos-header-sub   { font-size: 10px; color: rgba(255,255,255,0.6); margin-top: 1px; }

.combos-table { flex: 1; }

.combos-thead { background: #f5f8fa !important; }
.combos-th {
  color: #5a6a7a !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  border-bottom: 1px solid #e8edf2 !important;
}

.combos-row       { transition: background 0.15s; }
.combos-row:hover { background: #f0f5f8 !important; }
.combos-row--alt  { background: #fafcfe; }

.combos-td        { padding-top: 10px !important; padding-bottom: 10px !important; }
.combos-td--faixa { min-width: 150px; }

.faixa-wrap       { display: flex; align-items: center; }
.faixa-de         { font-size: 12px; font-weight: 600; color: #3d5166; }
.faixa-ate        { font-size: 12px; font-weight: 600; color: #3d5166; }
.faixa-sem-limite { font-size: 11px; font-weight: 500; color: #9aacbc; font-style: italic; }

.qtd-wrap         { display: inline-flex; align-items: center; }
.qtd-valor        { font-size: 13px; font-weight: 700; color: #023449; }

.desconto-valor {
  font-size: 13px;
  font-weight: 700;
  color: #023449;
  padding-right: 16px !important;
}

.combos-footer {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  background: #f5f8fa;
  border-top: 1px solid #e8edf2;
  font-size: 11px;
  color: #8fa8bc;
}

/* ════════════════════════════════════════════════════════════════════════
   COMO FUNCIONA
════════════════════════════════════════════════════════════════════════ */
.fluxo-card { display: flex; flex-direction: column; }

.fluxo-header {
  background: linear-gradient(135deg, #023449 0%, #035878 100%);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.fluxo-header-left  { display: flex; align-items: center; gap: 10px; }
.fluxo-header-icon  {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.fluxo-header-title { font-size: 13px; font-weight: 700; color: white; }
.fluxo-header-sub   { font-size: 10px; color: rgba(255,255,255,0.6); margin-top: 1px; }

/* Lista vertical de passos */
.fluxo-lista { display: flex; flex-direction: column; margin-bottom: 4px; }

.fluxo-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

/* Coluna esquerda: ícone + linha conectora */
.fluxo-item-esq {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.fluxo-item-wrap { position: relative; display: inline-flex; }

.fluxo-item-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fluxo-item-num {
  position: absolute;
  top: -6px;
  left: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

/* Linha vertical conectora entre passos */
.fluxo-item-linha {
  width: 2px;
  flex: 1;
  min-height: 16px;
  background: linear-gradient(to bottom, #dde8f0, #eef3f7);
  border-radius: 2px;
  margin: 4px 0;
  align-self: stretch;
}

/* Coluna direita: texto */
.fluxo-item-texto {
  padding-top: 6px;
  padding-bottom: 18px;
}
.fluxo-item:last-child .fluxo-item-texto {
  padding-bottom: 0;
}

.fluxo-item-label {
  font-size: 13px;
  font-weight: 700;
  color: #023449;
  line-height: 1.3;
}
.fluxo-item-desc {
  font-size: 11px;
  color: #8fa8bc;
  line-height: 1.5;
  margin-top: 2px;
}

/* Caixa de exemplo (card Sobre) */
.sobre-exemplo {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 14px;
  background: linear-gradient(135deg, #f0f8ff 0%, #e8f4fd 100%);
  border: 1px solid #c5e0f0;
  border-radius: 10px;
}
.sobre-exemplo-icone {
  width: 26px;
  height: 26px;
  background: rgba(4,119,161,0.1);
  border: 1px solid rgba(4,119,161,0.2);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.sobre-exemplo-titulo {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #0477a1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 3px;
}
.sobre-exemplo-texto {
  font-size: 12px;
  color: #3d6070;
  line-height: 1.55;
}

/* ── Mobile ────────────────────────────────────────────────────────────── */
@media (max-width: 599px) {
  .combos-td--faixa { min-width: unset; }
}
</style>
